<template>
  <div v-show="folder.show">
    <div class="row-tree" :class="row_tree_class" @click="select_folder">
      <div>
        <span :class="{'invisible': play_icon_hidden}" :style="depth_tree_style">
          <play-icon
            size="1x"
            :class="arrow_style"
            @click="toggle_folder"
          />
        </span>
        <span>
          <folder-icon size="1.5x" class="filled" />
        </span>
        <span class="path"> {{ folder.text }} </span>
      </div>
      <hr />
    </div>
    <hr />
    <folder-vue
      :bus="bus"
      :key="fold.id"
      v-for="fold in folder.children"
      :folder="fold"
    />
  </div>
</template>

<script>
import { FolderIcon, FileIcon, PlayIcon } from "vue-feather-icons";

export default {
  name: "folder-vue",
  components: { FolderIcon, FileIcon, PlayIcon },
  props: ["bus", "folder"],
  data() {
    return {
      arrow_opened: this.folder.arrow_open || false,
    };
  },
  computed: {
    row_tree_class() {
      return this.folder.selected ? "active" : "";
    },
    depth_tree_style() {
      return { marginLeft: `${this.folder.depth * 20}px` };
    },
    arrow_style() {
      return (
        (this.arrow_opened
          ? "feather feather-play ico-turn"
          : "feather feather-play ico") + " cursor-pointer"
      );
    },
    play_icon_hidden() {
      return this.folder.id == 0 || this.folder.children && this.folder.children.length == 0
    }
  },
  methods: {
    select_folder(e) {
      let data = {
        folder: this.folder,
      };
      this.bus.$emit("folder_selected", data);
      e.stopPropagation();
    },
    toggle_folder(e) {
      let data = {
        folder: this.folder,
      };
      this.arrow_opened = !this.arrow_opened;
      this.bus.$emit("arrow_toggle", data);
      e.stopPropagation();
    },
  },
};
</script>
